const Dynpack = require('od-apps/app.dynpack');
const CartService = require('./cart_service');
const cartErrors = require('./cart_errors');
const HOTEL_PARAMS_A = ['accommodationDeal.providerId', 'accommodationDeal.providerHotelId'];
const HOTEL_PARAMS_B = ['accommodationDeal.dedupId'];
const ROOM_PARAMS = ['roomGroupDeal.roomsId'];
const FLIGHT_PARAMS = ['flightPreselectedId', 'segmentsPreselected[0].key', 'segmentsPreselected[1].key'];

function hasMandatoryParameters(mandatoryAttributes) {
    return Odigeo._.every(mandatoryAttributes, (attribute) => !Odigeo._.isEmpty(Odigeo._.get(this.dynpackCartDetails, attribute)));
}

const manageServiceResponse = function(fetchedDetails) {
    return Odigeo._.isEmpty(fetchedDetails.dynpackErrors) ?
        cartResolve.call(this, fetchedDetails) :
        cartReject.call(this, fetchedDetails);
};

const manageRoomResponse = function(fetchedDetails) {
    return Odigeo._.isEmpty(fetchedDetails.dynpackErrors) ?
        roomResultsResolve.call(this, fetchedDetails) :
        cartReject.call(this, fetchedDetails);
};

const cartResolve = function(fetchedDetails) {
    this.cleanErrors();
    return this.extend(fetchedDetails);
};

const cartReject = function(fetchedDetails) {
    this.extend(fetchedDetails);
    cartErrors.errorsHandler(this.getErrors());
    return Promise.reject(this.getErrors());
};

const roomResultsResolve = function(rooms) {
    this.cleanErrors();
    return rooms;
};

class CartDetails {
    constructor(details = {}) {
        this.dynpackCartDetails = details;
    }

    create(searchParams) {
        return CartService.create(Odigeo._.extend({searchId: searchParams.searchId}, CartDetails.selectedProductParameters(searchParams))).then(
            manageServiceResponse.bind(this)
        );
    }

    fetchProduct(profile) {
        return CartService.getProfile(this.dynpackCartDetails.dynpackCartProductId, profile)
            .then(manageServiceResponse.bind(this));
    }

    updateProduct(selection) {
        return CartService.modify(this.dynpackCartDetails.dynpackCartProductId, CartDetails.selectedProductParameters(selection))
            .then(manageServiceResponse.bind(this));
    }

    confirmShoppingCart() {
        return CartService.confirm(this.dynpackCartDetails.dynpackCartProductId)
            .then(manageServiceResponse.bind(this));
    }

    getRoomResults() {
        return this.hasError(CartDetails.getErrorByProfile().accommodation) ?
            Promise.reject(this.getErrors()) :
            CartService.getRoomResults(this.dynpackCartDetails.dynpackCartProductId)
                .then(manageRoomResponse.bind(this));
    }

    getDetails() {
        return this.dynpackCartDetails;
    }

    getDynpackProductParameters() {
        return {
            accommodation: {
                key: Odigeo._.get(this.dynpackCartDetails, 'accommodationDeal.key', null),
                providerId: Odigeo._.get(this.dynpackCartDetails, HOTEL_PARAMS_A[0], null),
                providerHotelId: Odigeo._.get(this.dynpackCartDetails, HOTEL_PARAMS_A[1], null),
                dedupId: Odigeo._.get(this.dynpackCartDetails, HOTEL_PARAMS_B[0], null),
            },
            fareItinerary: {
                id: Odigeo._.get(this.dynpackCartDetails, FLIGHT_PARAMS[0], null),
                outboundFlight: Odigeo._.get(this.dynpackCartDetails, FLIGHT_PARAMS[1], null),
                returnFlight: Odigeo._.get(this.dynpackCartDetails, FLIGHT_PARAMS[2], null),
            },
            roomsId: Odigeo._.get(this.dynpackCartDetails, ROOM_PARAMS[0], null),
        };
    }

    getDynpackDeeplink() {
        return hasMandatoryParameters.call(this, HOTEL_PARAMS_A) ||
        hasMandatoryParameters.call(this, HOTEL_PARAMS_B) ||
        hasMandatoryParameters.call(this, FLIGHT_PARAMS)
            ? Dynpack.getDeeplinkWithShoppingCart(this.getDynpackProductParameters())
            : Dynpack.getDeeplinkWithoutShoppingCart();
    }

    extend(...details) {
        return Odigeo._.extend(this.dynpackCartDetails, ...details);
    }

    getErrors() {
        return this.dynpackCartDetails.dynpackErrors || [];
    }

    hasError(message) {
        return this.getErrors().some((error) => error.message === message);
    }

    cleanErrors() {
        this.dynpackCartDetails.dynpackErrors = [];
    }

    static getParametersByPage() {
        return {
            dpresults_accommodation: ['accommodationDeal', 'roomGroupDeal'],
            dpresults_accommodation_details: ['roomGroupDeal'],
            dpresults_flights: ['flightPreselectedId', 'segmentsPreselected'],
        };
    }

    static getProfiles() {
        return {
            flight: 'flight',
            accommodation: 'accommodation',
            room: 'room',
            allProducts: 'all-products',
        };
    }

    static getErrorByProfile() {
        return {
            accommodation: 'ACCOMMODATION_NOT_AVAILABLE',
            room: 'ACCOMMODATION_ROOM_NOT_AVAILABLE',
            flight: 'FLIGHT_NOT_AVAILABLE',
            allProducts: 'PACKAGE_NOT_AVAILABLE',
        };
    }

    static getErrorByPage() {
        return {
            dpresults_accommodation: 'ACCOMMODATION_NOT_AVAILABLE',
            dpresults_accommodation_details: 'ACCOMMODATION_ROOM_NOT_AVAILABLE',
            dpresults_flights: 'FLIGHT_NOT_AVAILABLE',
            allProducts: 'PACKAGE_NOT_AVAILABLE',
        };
    }

    static selectedProductParameters(data = {}) {
        return {
            accommodationKey: data.accommodationKey,
            providerId: data.providerId,
            providerHotelId: data.providerHotelId,
            dedupId: data.dedupId,
            roomGroupDealKey: data.roomGroupDealKey,
            roomsId: data.roomsId,
            fareItineraryKey: data.fareItineraryKey,
            segmentKeys: data.flightNumbers || data.segmentKeys,
            priceWithoutDiscountSelected: data.priceWithoutDiscountSelected
                || Odigeo.Utils.parseJson(Odigeo.Session.get('isDpNonPrimePriceSelected')),
        };
    }
}

module.exports = CartDetails;
